import { FieldProps, getIn } from 'formik';
import { FileInputProps, FileInputField } from '../FileInputField/FileInputField';
import { FormHelperText } from '../../shared/components/FormHelperText/FormHelperText';

export function FormikFileInputField({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  onChangeEventHandler,
  helperText = null,
  ...props
}: FileInputProps & FieldProps) {
  const showError =
    (touched[field.name] && !!errors[field.name]) ||
    (getIn(errors, field.name) && getIn(touched, field.name));

  return (
    <FileInputField
      {...props}
      {...field}
      id={field.name}
      helperText={FormHelperText({
        helperText,
        showError,
        fieldName: field.name,
        errorMessage: errors[field.name] as string | string[]
      })}
      error={!!showError}
      onBlur={async () => {
        await setFieldTouched(field.name, true);

        if (props.onBlur) {
          props.onBlur();
        }
      }}
      value={field.value}
      dataId={field.name}
      onChangeEventHandler={async files => {
        if (onChangeEventHandler) {
          onChangeEventHandler(files);
        } else {
          await setFieldValue(field.name, files);
        }
      }}
    />
  );
}
